import actSuccessAlertDictionary from '@widgets/act-success-alert/i18n/ru/act-success-alert.dic.json';

export const actSuccessAlert = {
  ACT_SUCCESS_ALERT: actSuccessAlertDictionary,
};

export const actSuccessAlertNamespaces = ['ACT_SUCCESS_ALERT'];
